import { motion } from "framer-motion";
import styles from "../assets/styles/Workflow.module.css";
import waves from "../assets/images/wavesdownhero.svg"

const steps = [
  {
    id: 1,
    title: "Identify Problem",
    description: "We start by understanding your challenge in depth.",
  },
  {
    id: 2,
    title: "Do You Have a Solution?",
    description: "We branch depending on whether you already have a solution.",
    branch: [
      {
        id: 2.1,
        title: "Yes → We Implement",
        description: "We take your existing solution and bring it to life simpel as that.",
      },
      {
        id: 2.2,
        title: "No → Find a Solution & Refine",
        description: "Other wise We propose a solution and refine it together.",
      },
    ],
  },
  {
    id: 3,
    title: "Outline Project Scope",
    description: "Define goals, timelines, and constraints clearly.",
  },
  {
    id: 4,
    title: "Design Architecture",
    description:
      "We design a robust architecture considering budget, time, and no corners cutting on security.",
  },
  {
    id: 5,
    title: "Develop MVP",
    description: "Then we Create a functional prototype to validate the idea.",
  },
  {
    id: 6,
    title: "Present Demo & Refactor",
    description:
      "We showcase the MVP, get feedback, and refine for perfection.",
  },
  {
    id: 7,
    title: "Ship Final Product",
    description: "Deliver a polished, scalable, and secure final product.",
  },
];

// export default function Workflow2() {
//   return (
//     <section className={styles.workflowSection}>
//       <h2 className={styles.header}>Our Work Process</h2>
//       <div className={styles.timeline}>
//         {steps.map((step, index) => (
//           <motion.div
//             key={step.id}
//             className={`${styles.step} ${
//               index % 2 === 0 ? styles.left : styles.right
//             }`}
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <div className={styles.content}>
//               <h3>{step.title}</h3>
//               <p>{step.description}</p>

//               {step.branch && (
//                 <div className={styles.branchWrapper}>
//                   {step.branch.map((b) => (
//                     <motion.div
//                       key={b.id}
//                       className={styles.branch}
//                       initial={{ opacity: 0, y: 20 }}
//                       whileInView={{ opacity: 1, y: 0 }}
//                       viewport={{ once: true }}
//                       transition={{ duration: 0.5, delay: 0.2 }}
//                     >
//                       <h4>{b.title}</h4>
//                       <p>{b.description}</p>
//                     </motion.div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </section>
//   );
// }


export default function Workflow2() {
  return (
     <div className={styles.beforemain}>
    <section className={styles.workflowSection}>
      <h2 className={styles.header}>STEP BY STEP</h2>
      <div className={styles.timeline}>
        {steps.map((step, index) => (
          <motion.div
  key={step.id}
  className={`${styles.step} ${index % 2 === 0 ? styles.left : styles.right}`}
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6 }}
>
  {/* Step Circle with Number */}
  <div className={styles.circle}>{index + 1}</div>

  <div className={styles.content}>
    <h3>{step.title}</h3>
    <p>{step.description}</p>

    {step.branch && (
      <div className={styles.branchWrapper}>
        {step.branch.map((b) => (
          <motion.div
            key={b.id}
            className={styles.branch}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h4>{b.title}</h4>
            <p>{b.description}</p>
          </motion.div>
        ))}
      </div>
    )}
  </div>
</motion.div>

        ))}
      </div>
    </section>
       <img className={styles.lowerImg} src={waves}/>
    </div>
  );
}